import { Alert } from '../Alert/Alert';

export const NetworkStatusAlert = ({ isOnline }: { isOnline: boolean }) => {
  return !isOnline ? (
    <Alert severity="warning" sx={{ marginBottom: 2 }}>
      You are currently offline, evidence will be stored locally until you are back online.
    </Alert>
  ) : null;
};
